const translation = {
  // Navigation
  nav_home: "Ana Sayfa",
  nav_categories: "Kategoriler",
  nav_routes: "Rotalar",
  nav_map: "Harita",
  nav_for_business: "İşletmem",
  nav_explore_btn: "Keşfet",
  nav_cat_historical: "Tarihi Yerler",
  nav_cat_food: "Lezzet Durakları",
  nav_cat_entertainment: "Eğlence",
  nav_cat_accommodation: "Konaklama",
  nav_cat_nature: "Doğa ve Rotalar",
  nav_cat_sightseeing: "Gezilecek Yerler",
  nav_cat_featured: "Öne Çıkan Mekanlar",

  // Hero
  hero_badge: "Türkiye'nin Yeşil Cenneti",
  hero_title_1: "Bursa'yı",
  hero_title_2: "360°",
  hero_title_3: "Keşfedin",
  hero_subtitle: "Tarihi yapılar, doğal güzellikler, lezzet durakları — Bursa'nın her köşesine en iyi rehberiniz.",
  hero_search_placeholder: "Mekan, kategori veya rota ara...",
  hero_search_btn: "Ara",
  hero_stat_1_num: "500+",
  hero_stat_1_label: "Keşfedilecek Mekan",
  hero_stat_2_num: "85+",
  hero_stat_2_label: "Lezzet Durağı",
  hero_stat_3_num: "12",
  hero_stat_3_label: "Hazır Rota",
  hero_stat_4_num: "4.8",
  hero_stat_4_label: "Ortalama Puan",
  hero_quick_label: "Hızlı Erişim:",
  hero_quick_history: "Tarihi Yerler",
  hero_quick_food: "Yemek",
  hero_quick_nature: "Doğa",
  hero_quick_hotels: "Oteller",
  hero_quick_fun: "Eğlence",

  // Categories section
  cat_section_badge: "Kategoriler",
  cat_section_title: "Ne Keşfetmek İstiyorsunuz?",
  cat_section_subtitle: "Tarihi alanlardan doğa rotalarına, lezzet duraklarından konaklamaya — her şey burada.",
  cat_historical_title: "Tarihi Yerler",
  cat_historical_desc: "Osmanlı mirası, UNESCO alanları ve tarihi mekanlar",
  cat_historical_count: "120+ mekan",
  cat_food_title: "Lezzet Durakları",
  cat_food_desc: "İskender, pideli köfte ve Bursa'nın eşsiz tatları",
  cat_food_count: "85+ restoran",
  cat_entertainment_title: "Eğlence",
  cat_entertainment_desc: "Macera parkları, aktiviteler ve gece hayatı",
  cat_entertainment_count: "60+ mekan",
  cat_accommodation_title: "Konaklama",
  cat_accommodation_desc: "Butik oteller, termal tesisler ve tatil köyleri",
  cat_accommodation_count: "200+ seçenek",
  cat_nature_title: "Doğa ve Rotalar",
  cat_nature_desc: "Uludağ, göller, patikalar ve doğa yürüyüşleri",
  cat_nature_count: "40+ rota",
  cat_sightseeing_title: "Gezilecek Yerler",
  cat_sightseeing_desc: "Müzeler, çarşılar, köyler ve panoramik noktalar",
  cat_sightseeing_count: "95+ yer",
  cat_featured_title: "Öne Çıkan Mekanlar",
  cat_featured_desc: "Editörlerin önerdiği en iyi adresler",
  cat_featured_count: "Editör seçimi",
  cat_view_all: "Tümünü Gör",

  // Featured section
  featured_badge: "Öne Çıkan",
  featured_title: "Bu Hafta Önerilen Mekanlar",
  featured_subtitle: "Editörlerimizin ve ziyaretçilerimizin en çok beğendiği adresler.",
  featured_view_all: "Tüm Mekanları Gör",
  featured_sponsored: "Sponsorlu",
  featured_editor: "Editör Seçimi",
  featured_open: "Açık",
  featured_closed: "Kapalı",
  featured_details: "Detaya Git",
  featured_directions: "Yol Tarifi",
  featured_km_away: "km uzakta",
  featured_reviews: "yorum",

  // Routes section
  routes_badge: "Hazır Rotalar",
  routes_title: "Bursa'yı Planla",
  routes_subtitle: "Uzmanlarımızın hazırladığı rota önerileri — zamanınıza ve ilgi alanınıza göre seçin.",
  routes_view_all: "Tüm Rotalar",
  routes_hours: "saat",
  routes_stops: "durak",
  routes_start: "Rotayı Başlat",
  routes_difficulty_easy: "Kolay",
  routes_difficulty_medium: "Orta",
  routes_difficulty_hard: "Zorlu",
  routes_day1_title: "Bir Günde Bursa",
  routes_day1_desc: "Şehrin en ikonik noktalarını tek günde keşfedin",
  routes_history_title: "Tarihi Bursa Rotası",
  routes_history_desc: "Osmanlı'nın izini süren kapsamlı tarih turu",
  routes_food_title: "Lezzet Turu",
  routes_food_desc: "Bursa'nın en iyi tatlarını tüm gün boyunca keşfedin",
  routes_family_title: "Aile Rotası",
  routes_family_desc: "Çocuklar ve aileler için eğlenceli ve rahat bir Bursa turu",
  routes_weekend_title: "Hafta Sonu Planı",
  routes_weekend_desc: "2 günlük kapsamlı Bursa deneyimi, her şey dahil",

  // Nearby section
  nearby_badge: "Size Özel",
  nearby_title: "Benim İçin En Uygun Duraklar",
  nearby_subtitle: "Konumunuza yakın, farklı kategorilerden öneriler. Hem tarihi hem de lezzetli hem de dinlendirici.",
  nearby_location_btn: "Konumumu Kullan",
  nearby_using_location: "Konum alınıyor...",
  nearby_view_all: "Daha Fazla Gör",
  nearby_km_away: "km uzakta",
  nearby_permission_title: "Yakınımdaki Yerleri Gör",
  nearby_permission_desc: "Konumunuzu paylaşın; size en yakın tarihi yerler, restoranlar ve otelleri anında gösterelim.",
  nearby_no_permission: "Konum erişimi reddedildi. Lütfen tarayıcı ayarlarınızdan izin verin.",

  // Campaigns section
  campaigns_badge: "Fırsatlar",
  campaigns_title: "Kampanyalar & İndirimler",
  campaigns_subtitle: "Bursa'nın en iyi mekanlarında size özel fırsatlar ve kuponlar.",
  campaigns_view_all: "Tüm Kampanyalar",
  campaigns_expires: "Son tarih",
  campaigns_get_coupon: "Kuponu Al",
  campaigns_sponsored: "Sponsorlu",
  campaigns_discount: "indirim",

  // Chatbot
  chatbot_title: "Bursa Asistanı",
  chatbot_subtitle: "Rota önerileri, mekan bilgileri için sorun",
  chatbot_greeting: "Merhaba! Bursa'da ne yapmak istiyorsunuz? Size en iyi rotayı, mekanları ve önerileri sunmaktan mutluluk duyarım.",
  chatbot_placeholder: "Bir şey sorun...",
  chatbot_send: "Gönder",
  chatbot_suggestion_1: "Bugün ne yapabilirim?",
  chatbot_suggestion_2: "En iyi tarihi yerler",
  chatbot_suggestion_3: "Rota öner",
  chatbot_suggestion_4: "Çocuklarla nereye gidebilirim?",
  chatbot_suggestion_5: "En iyi restoranlar",

  // Footer
  footer_tagline: "Bursa'yı 360° Keşfedin",
  footer_desc: "BursaGuide360, Bursa'yı ziyaret eden herkes için kapsamlı bir dijital şehir rehberi platformudur. Tarihi, doğası, lezzetleri ve daha fazlası bir arada.",
  footer_links_title: "Hızlı Bağlantılar",
  footer_categories_title: "Kategoriler",
  footer_contact_title: "İletişim",
  footer_address: "Osmangazi, Bursa, Türkiye",
  footer_phone: "+90 224 000 0000",
  footer_email: "info@bursaguide360.com",
  footer_rights: "© 2026 BursaGuide360. Tüm hakları saklıdır.",
  footer_privacy: "Gizlilik Politikası",
  footer_terms: "Kullanım Koşulları",
  footer_for_business: "İşletmem İçin",
  footer_newsletter_title: "Bursa Haberleri",
  footer_newsletter_desc: "Yeni mekanlar ve kampanyalardan ilk siz haberdar olun.",
  footer_newsletter_placeholder: "E-posta adresiniz",
  footer_newsletter_btn: "Abone Ol",

  // Category page
  cat_page_results: "mekan bulundu",
  cat_page_no_results: "Sonuç bulunamadı",
  cat_page_no_results_desc: "Filtrelerinizi değiştirerek tekrar deneyin.",
  cat_page_reset_filters: "Filtreleri Temizle",
  cat_page_filter_title: "Filtreler",
  cat_page_filter_district: "İlçe",
  cat_page_filter_sort: "Sıralama",
  cat_page_filter_type: "Tür",
  cat_page_sort_popular: "En Popüler",
  cat_page_sort_rating: "En Yüksek Puan",
  cat_page_sort_distance: "En Yakın",
  cat_page_sort_newest: "En Yeni",
  cat_page_filter_open: "Şu An Açık",
  cat_page_filter_sponsored: "Sponsorlu",
  cat_page_filter_editor: "Editör Seçimi",
  cat_page_load_more: "Daha Fazla Göster",
  cat_page_showing: "gösteriliyor",
  cat_page_view_detail: "Detayları Gör",
  cat_page_directions: "Yol Tarifi",
  cat_page_breadcrumb_home: "Ana Sayfa",
  cat_page_breadcrumb_cat: "Kategoriler",
  cat_page_all_categories: "Tüm Kategoriler",
  cat_page_sponsored_banner_title: "İşletmenizi Öne Çıkarın",
  cat_page_sponsored_banner_desc: "Hedef kitlenize ulaşın. Sponsorlu içerik ile binlerce ziyaretçiye görünün.",
  cat_page_sponsored_banner_cta: "Reklam Ver",
  cat_page_km: "km",
  cat_page_reviews: "yorum",

  // Common
  common_open: "Açık",
  common_closed: "Kapalı",
  common_sponsored: "Sponsorlu",
  common_featured: "Öne Çıkan",
  common_editor_pick: "Editör Seçimi",
  common_view_details: "Detayları Gör",
  common_get_directions: "Konum Tarifi Al",
  common_book_now: "Rezervasyon Yap",
  common_explore: "Keşfet",
  common_see_all: "Tümünü Gör",
  common_km_away: "km uzakta",

  // QR page
  qr_badge: "Hoş Geldiniz!",
  qr_title: "Otelden Çıkınca Yapılacak",
  qr_title_accent: "İlk 5 Şey",
  qr_desc: "Bursa'da ilk saatlerinizi en iyi geçirmek için editörlerimizin seçtiği 5 öneri.",
  qr_item1_title: "Extrempark'a Gidin",
  qr_item1_desc: "Şehrin en iyi manzara noktası. Dağ kızağı, dev salıncak ve seyir terası.",
  qr_item1_cta: "Bilet Al",
  qr_item2_title: "Yeşil Cami'ye Uğrayın",
  qr_item2_desc: "Otelden 10 dakika — Osmanlı çini sanatının en nefes kesen örneği.",
  qr_item2_cta: "Yol Tarifi",
  qr_item3_title: "İskender Kebap Yiyin",
  qr_item3_desc: "1867'de Bursa'da icat edilen bu yemek şehrin kimliğidir.",
  qr_item3_cta: "Mekanı Gör",
  qr_item4_title: "Teleferikle Uludağ'a Çıkın",
  qr_item4_desc: "Şehirden zirveye 8 dakikalık panoramik yolculuk.",
  qr_item4_cta: "Saatleri Gör",
  qr_item5_title: "Cumalıkızık'ta Gezin",
  qr_item5_desc: "700 yıllık Osmanlı köyü. Taş evler, kahvaltı ve nostalji.",
  qr_item5_cta: "Haritada Gör",
  qr_back: "Tam Rehbere Dön",
  qr_powered: "BursaGuide360 tarafından",

  // Sticky
  sticky_label: "Yakınımdaki Yerler",
};

export default translation;
